export default __webpack_public_path__ + "static/media/Bild5.7b4cd3ca.jpeg";